import React, { FC, useEffect, useState } from 'react';
import Dropdown from '~/src/components/form-components/dropdown/dropdown';
import { EMPTY_REGION_TEXT } from '~/src/components/common-components/region-field/region-field.constants';
import {
    getRegionComponentItem,
    prepareDataFromDropdownRegions,
} from '~/src/components/common-components/region-field/region-field.utils';
import { getEmptyOutputData } from '~/src/helpers/empty-output';
import type { DropDownRegionProps, SuggestedType } from '~/src/models/types/fields.types';
import type { CustomInputChangeInterface } from '~/src/components/form-components/dropdown/dropdown.types';

export const RegionField: FC<DropDownRegionProps> = ({
    regionsData,
    onSuggestedValueChange,
    onValueChange,
    setHasError,
    ...props
}) => {
    const [regionValue, setRegionValue] = useState('');
    const [regionError, setRegionError] = useState('');
    const [regionsDataState, setRegionsDataState] = useState(regionsData);
    const [suggestedRegionData, setSuggestedRegionData] = useState<SuggestedType>({});

    const onValueChangeRegionHandler = (value: string) => {
        setRegionValue((value || '').trim());
        onValueChange?.(value);
        setRegionError(EMPTY_REGION_TEXT);
    };

    const onSuggestedValueHandler = (value: CustomInputChangeInterface) => {
        setSuggestedRegionData(value);

        if (onSuggestedValueChange) {
            onSuggestedValueChange(value);
        }
    };

    useEffect(() => {
        if (!regionValue) {
            setRegionsDataState(regionsData);
            return;
        }

        const regionsDataFiltered = regionsData.filter((elem) => {
            return elem.name.toLowerCase().includes(regionValue.toLowerCase());
        });

        setRegionsDataState(regionsDataFiltered);
    }, [regionValue]);

    useEffect(() => {
        setRegionError('');
    }, [suggestedRegionData]);

    useEffect(() => {
        if (!regionError.length) {
            setHasError && setHasError(false);
        }
        regionError?.length && setHasError && setHasError(true);
    }, [regionError]);

    return (
        <Dropdown
            value={regionValue}
            error={regionError}
            options={prepareDataFromDropdownRegions({
                data: regionsDataState,
                callback: getRegionComponentItem,
            })}
            emptyOutputData={getEmptyOutputData(EMPTY_REGION_TEXT)}
            onValueChange={onValueChangeRegionHandler}
            onSuggestedValueChange={onSuggestedValueHandler}
            {...props}
        />
    );
};
